module.exports = __webpack_public_path__ + "img/icon-date.702c2164.svg";